/**
 * @function v3sTreemenu
 * @memberOf v3sWbtPlayerApp:page:elements
 * @description
 * Erzeugt ein aufklappbares Menü mit einem Ausschnitt des Navigationsbaums.
 */
angular.module('v3sWbtPlayerApp').directive('v3sTreemenu', ["v3sWbtDataService", "v3sNavigationService", "$timeout", function (v3sWbtDataService, v3sNavigationService, $timeout) {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            v3sItemid: '@',
            v3sTop: '@'
        },
        templateUrl: "app/js/page/elements/v3sTreemenu.tpl.html",
        link: {
            pre: function (scope, element, attrs) {
                var i, children;
                var wbt = v3sWbtDataService.getWbt();

                if (scope.v3sItemid) {
                    scope.rootItem = wbt.getItem(scope.v3sItemid);
                } else {
                    scope.rootItem = wbt;
                }

                scope.children = [];

                if (scope.rootItem) {
                    children = scope.rootItem.getChildren();

                    for (i = 0; i < children.length; i++) {
                        if (children[i].getTreeParent() == scope.rootItem) {
                            scope.children.push(children[i]);
                        }
                    }
                }

                scope.expanded = false;
                scope.$watch('expanded', function (newValue, oldValue) {
                    if (oldValue != newValue) {
                        if (newValue) {
                            var treemenu = angular.element(element.children()[0]);
                            treemenu.addClass("expanded");

                            var viewPort = document.getElementById("page-view");

                            var viewPortHeight = viewPort.offsetHeight;
                            var elHeight = treemenu[0].offsetHeight;

                            if ((parseInt(scope.v3sTop) + elHeight) > viewPortHeight) {
                                element.css("top", (viewPortHeight - elHeight - 5) + "px");
                            }

                        } else {
                            element.css("top", scope.v3sTop + "px");
                        }
                    }
                });
            }
        }
    }
}]);
